<template>
    <div class="header no-gutters" >
      <!-- <div class=" relative"> -->
        <div class="inline-block text-left logo">
          <img  class="item" src="@static/img/common/logo.png" alt="logo">
        </div>
        <div class="inline-block text-left nav-title">
          <span @click="go('/home')" :class="[ this.$route.path === '/home' ? 'active' : '' ]" class="item title" v-text="$t('header.home')"></span>
          <span @click="go('/cooperation_case')" :class="[ this.$route.path === '/cooperation_case' ? 'active' : '' ]" class="item title" v-text="$t('header.cooperation_case')"></span>
          <span @click="go('/product_introduce')" :class="[ this.$route.path === '/product_introduce' ? 'active' : '' ]" class="item title" v-text="$t('header.product_introduce')"></span>         
          <span @click="go('/news')" :class="[ this.$route.path === '/news' ? 'active' : '' ]" class="item title" v-text="$t('header.news')"></span>
          <span @click="go('/aboutus')" :class="[ this.$route.path === '/aboutus' ? 'active' : '' ]" class="item title" v-text="$t('header.about_us')"></span>
        </div>
        <div class="inline-block contactusbox">
          <!-- <span class="btn item" href="#" role="button">{{$t('header.contact_us')}}</span> -->
          <!-- <ContactUs></ContactUs> -->
        </div>
        <!-- <div class="inline-block language">
          <div class="dropdown">
            <button @click="showCchangeLanguageBox()" class="btn  dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
              <span v-text="currentLanguage.name">ENGLISH</span>
              <span class="caret"></span>
            </button>
            <ul id="languageList" class="dropdown-menu" aria-labelledby="dropdownMenu1">
              <li @click="changeLanguage(item)" v-for="(item, i) in languages" ><a  :class="{ 'active-menu': item.code === currentLanguage.code }" href="#">{{item.name}}</a></li>
            </ul>
          </div>
        </div> -->
      <!-- </div> -->
  </div>
</template>

<script>
import languages from '@/assets/lang/config'
export default {
  name: 'Header',
  created () {
    this.languages = languages;
    this.changeLanguage(this.languages[0], true);
  },
  // components: {
  //   ContactUs
  // },
  data () {
    return {
      "languageList" : false,
      "currentLanguage" : {},
      "languages" :[],
    }
  },
  methods : {
    changeLanguage : function (param, init) {
      console.log(param)

      if(undefined !== param.code) {
        // 选择的中文则直接跳转到中文官网
        // if('zh-CN' === param.code) {
        //   window.location.href = "http://www.xiudianer.com/";
        // } else {
          this.$i18n.locale = param.code;
          this.currentLanguage = param;

          window.document.querySelector("title").innerText = this.$t('page_title');
        // }
        
        if(true !== init) {
          this.showCchangeLanguageBox();
        }
      }
    },
    showCchangeLanguageBox : function () {
      if(!this.languageList) {
        $("#languageList").css({"display":"block"});
        this.languageList = true;
      } else {
        $("#languageList").css({"display":"none"});
        this.languageList = false;
      }
      
      
    },
    go : function (url) {
       this.$router.push({path:url})
       
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.header .language .dropdown-menu .active-menu {
   color:#13B88A;
}

.header .language .dropdown-menu {
  display: block;
  border-radius: 20px;
  width: 150px;
  font-size: 16px;
  left: -25px;
  margin: 11px 0 0;
  display: none;
}

.header .language .dropdown-menu a:hover {
  background-color: transparent;
  color:#13B88A;
}

.header .language .dropdown-menu > li > a {
  padding: 0px 0px 0px 0px;
}


.header .language  .dropdown-menu > li:not(:last-child)::after {
  content: '';
  display: inline-block;
  height: 1px;
  width: 80%;
  border: 1px solid #E6E6E6;
}

.header .language  .dropdown-menu > li  {
  margin-top: 10px;
  text-align: center;
}

.header .language .dropdown-menu > li:last-child  {
  margin-bottom: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue